/** Allowlisted operational state only: no tokens, candidate details, or device IDs. */
export interface InterviewRumContext {
  callId: string | null;
  started: boolean;
  callEnded: boolean;
  isReconnecting: boolean;
  connectionAttempts: number;
  gracefulEnding: boolean;
  userInitiatedHangup: boolean;
  isOnline: boolean | undefined;
}

type ContextReader = () => InterviewRumContext;

let activeRegistration: { read: ContextReader } | undefined;

/** Register from an effect so abandoned renders never claim the active session. */
export function registerInterviewRumContext(read: ContextReader): () => void {
  const registration = { read };
  activeRegistration = registration;
  return () => {
    // An old session's cleanup must not erase a newer session's context.
    if (activeRegistration === registration) {
      activeRegistration = undefined;
    }
  };
}

/** Read at event time so synchronous hangup/reconnect refs stay current. */
export function getInterviewRumContext(): InterviewRumContext | undefined {
  return activeRegistration?.read();
}
